import { isProd } from "../../util/functions";

const API_VERSION = "/api/v1";

const baseURL = () => {
  if (isProd) {
    return `https://media.api.mystoriesmatter.com${API_VERSION}`;
  }

  return `https://qa-media.api.mystoriesmatter.com${API_VERSION}`;
};

export const uploadImagesUrl = () => `${baseURL()}/media/unprocessed`;
